
<template>
  <div>
    <v-dialog
      v-model="dialog"
      scrollable
      persistent :overlay="false"
      max-width="500px"
      transition="dialog-transition"
    >
      <template v-slot:activator="{ on, attrs }">
        <div class="d-flex">
          <v-spacer></v-spacer>
          <v-btn small color="primary" dark v-bind="attrs" v-on="on"><v-icon left>mdi-pencil</v-icon>Editar</v-btn>
        </div>
      </template>

      <v-card style="border-radius:12px">
        <v-card-title primary-title>
          <div class="headline mb-0">Editando contato</div>
        </v-card-title>
        <v-card-text>
          <contact-form ref="form3" :contact="contact"></contact-form>
        </v-card-text>
        <v-card-actions class="justify-end">
          <f-btn @click="cancelChanges" cancel></f-btn>
          <f-btn @click="saveInfo" save></f-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <dialog-loading loadingText="Salvando..." v-if="saving"></dialog-loading>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  name: 'DialogEditContact',
  components: {
    ContactForm: () => import('@/_backoffice/_registrations/components/shared/forms/ContactForm.vue'),
  },
  data() {
    return {
      dialog: false,
      saving: false,
      contact: {},
    }
  },
  mounted () {
    this.contact = {...this.one_modality.contact};
  },
  methods: {
    ...mapActions({
      saveContact: 'Modality/saveContact',
    }),

    cancelChanges() {
      this.contact = {...this.one_modality.contact}
      this.dialog = false
    },

    saveInfo() {
      const validate = this.$refs.form3.validate()
      if (validate) {
        this.swallConfirmation({
          title: 'Deseja atualizar informações do galpão?',
          icon: 'question',
        }).then( confirmed =>{
          if (confirmed ) {
            this.saving = true
            this.saveContact({contact: this.contact, contact_idx: this.contact_idx}).then(() => {
              this.dialog = false
            }).catch(err => {
              console.log(err)
            }).finally(()=>{
              this.saving = false
            })
          }
        })
      }
    },
  },
  computed: {
    name() {
      return null
    },
    ...mapState({
      one_modality: state => state.Modality.one_modality
    })
  },
  watch: {
  },
}
</script>

<style scoped>

</style>
